import * as actions from "../global/actionTypes";

const initState = {
  showSideBar: true,
};

export default function (state = initState, action = {}) {
  switch (action.type) {
    case actions.TOGGLE_SIDEBAR:
      return {
        showSideBar: !state.showSideBar,
      };
    default:
      return state;
  }
}
